import { Breakpoints } from "utilities/enumerations/breakpoints";
import useBreakpoint, {
    BreakpointComparer,
} from "utilities/hooks/use-breakpoint";
/**
 * Uses the `useBreakpoint` hook to return a boolean indicating
 * the screen width is in between the lower and upper bounds given
 * @param lowerBound lowest possible width allowed
 * @param upperBound highest possible width allowed
 */
const useBreakpointRange = (
    lowerBound: Breakpoints,
    upperBound: Breakpoints
) => {
    const isBelowMin = useBreakpoint(lowerBound, BreakpointComparer.MaxWidth);
    const isBelowMax = useBreakpoint(upperBound, BreakpointComparer.MaxWidth);

    return isBelowMax && !isBelowMin;
};

export default useBreakpointRange;
